<template>
    <ul class="pagination pagination-sm m-0 p-2 flex-wrap">
        <li :class="'page-item ' + (current_page == 1 ? 'disabled' : '')">
            <a class="page-link" href="#" @click.prevent="goTo(1)">PRIMERA</a>
        </li>


        <li :class="'page-item ' + (current_page == 1 ? 'disabled' : '')">
            <a class="page-link" href="#" @click.prevent="goTo(current_page - 1)">«</a>
        </li>

        <template v-for="(page, index) in pages">
            <li v-if="page > 0 && page <= last_page" :key="index" :class="'page-item ' + (current_page == page ? 'disabled' : '')">
                <a class="page-link" href="#" @click.prevent="goTo(page)">{{ page }}</a>
            </li>
        </template>

        <li :class="'page-item ' + (current_page == last_page ? 'disabled' : '')">
            <a class="page-link" href="#" @click.prevent="goTo(current_page + 1)">»</a>
        </li>

        <li :class="'page-item ' + (current_page == last_page ? 'disabled' : '')">
            <a class="page-link" href="#" @click.prevent="goTo(last_page)">ÚLTIMA</a>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        'current_page': Number,
        'last_page': Number
    },
    data() {
        return {
            pages: []
        }
    },
    created() {
        this.setPages();
    },
    watch: {
        current_page() {
            this.setPages();
        },
        last_page() {
            this.setPages();
        }
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        setPages() {
            this.pages = [];
            for (var i = this.current_page - 3; i <= this.current_page + 3; i++) {
                this.pages.push(i);
            }
        },
        goTo(page) {
            if(page != this.current_page) {
                this.$emit('change_page', page);
            }
        }
    }
}
</script>
